<template>
  <v-tooltip v-if="show" bottom class="mr-2">
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <v-icon
          :color="color"
          :class="{ 'ml-4': !mobile, 'ml-2': mobile }"
          small
          >{{ icon }}
        </v-icon>
      </div>
    </template>
    <p class="white--text">{{ title }}</p>
  </v-tooltip>
</template>

<script>
export default {
  props: ['show', 'icon', 'title', 'color'],
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.xs
    }
  }
}
</script>
